export const OPPORTUNITIES_REQUEST_PENDING = 'opportunitites_request_pending';
export const OPPORTUNITIES_REQUEST_RECEIVED = 'opportunities_request_received';
export const OPPORTUNITIES_REQUEST_ERROR = 'opportunities_request_error';

export const UPDATE_OPPORTUNITY_FLOW_TYPE_PENDING = 'update_opportunity_flow_type_pending';
export const UPDATE_OPPORTUNITY_FLOW_TYPE_RECIEVED = 'update_opportunity_flow_type_recieved';
export const UPDATE_OPPORTUNITY_FLOW_TYPE_ERROR = 'update_opportunity_flow_type_error';
